@if (balance !== null && balance !== undefined) {
  <p class="available">
    Available:
    <span class="value">{{ balance | formatCoinCurrency: precision }} {{ currencySymbol }}</span>
    @if (showMax) {
      <span class="max" (click)="onMaxClick()">MAX</span>
    }
  </p>
}
